import { render, staticRenderFns } from "./MailLight.vue?vue&type=template&id=d47241e2"
import script from "./MailLight.vue?vue&type=script&setup=true&lang=ts"
export * from "./MailLight.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports